<div class="d-flex multiple-avatar-display-size-{{ size }}">
  <omgui-profile-bubble
    *ngFor="let profile of displayedProfiles"
    [profile]="profile"
    [size]="size"
    class="outline"
  ></omgui-profile-bubble>
</div>
